// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".powered-by-po-header{display:grid;grid-template-rows:min-content}", "",{"version":3,"sources":["webpack://./src/components/common/ui-widgets/powered-by-po-header.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,8BAAA","sourcesContent":[".powered-by-po-header {\n    display: grid;\n    grid-template-rows: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
